import React from "react";

/** Green background with a white line-chart */
export const ReportingZoneIcon: React.FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#16A34A" />
    {/* Chart backdrop */}
    <rect x="7" y="7" width="26" height="26" rx="2.5" fill="white" fillOpacity="0.18" />
    {/* Axes */}
    <line x1="11" y1="11" x2="11" y2="29" stroke="white" strokeWidth="1.5" strokeOpacity="0.75" strokeLinecap="round" />
    <line x1="11" y1="29" x2="29" y2="29" stroke="white" strokeWidth="1.5" strokeOpacity="0.75" strokeLinecap="round" />
    {/* Trend line */}
    <polyline
      points="13,26 17,20 21,22 27,14"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);
